// constants.js
// BaseURL
export const BASE_URL = "http://localhost:5000/api/migpath";
// export const BASE_URL = "https://j2ghscs3gh.execute-api.eu-north-1.amazonaws.com/dev";
// export const BASE_URL = "https://www.srv741090.hstgr.cloud";
// export const BASE_URL = "http://localhost:5500";